import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";
import LoginComponent from "./login";
import Notify from "../common/notify/notify";
import { connect } from "react-redux";
import { userLogin } from "../../redux/slice/userLoginSlice";
import { userAuthentication } from "../../redux/slice/userAuthenticationSlice";

const Login = (props) => {
  const { calluserLoginData, calluserAuthenticationData, userLoginData } =
    props;

  const [formData, setFormData] = useState({
    phone_number: "",
    code: "",
  });

  const [validation, setValidation] = useState({});
  const cookies = new Cookies();
  const navigate = useNavigate();
  const loading = userLoginData.isLoading;

  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;

      const validateToken = async () => {
        const token = cookies.get("token");
        if (token) {
          const result = await calluserAuthenticationData();
          if (result.type !== "userAuthentication/fulfilled") {
            cookies.remove("token");
            Notify(
              "error",
              "Your login session is no longer valid. Please sign in again to proceed..",
              ""
            );
            navigate("/login");
          }
        }
      };

      validateToken();
    }
  }, [calluserAuthenticationData, cookies, navigate]);

  const handleLogin = (event) => {
    const { name, value } = event.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: name === "phone_number" ? Number(value) : value,
    }));

    setValidation((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const handleOtp = (event) => {
    setFormData((prevState) => ({
      ...prevState,
      code: event.toString(),
    }));
    setValidation((prevState) => ({
      ...prevState,
      code: "",
    }));
  };

  const handleSubmit = async () => {
    let error = {};

    if (!formData.phone_number) {
      error.phone_number = "Please provide a phone number to proceed.";
    } else if (!/^\d{10,12}$/.test(formData.phone_number.toString())) {
      error.phone_number = "Enter a valid phone number with 10 to 12 digits.";
    }

    if (!formData.code) {
      error.code = "Please provide a PIN to proceed.";
    }

    setValidation(error);

    if (Object.keys(error).length === 0) {
      try {
        const loginResult = await calluserLoginData({
          ...formData,
          phone_number: Number(formData.phone_number),
        });

        if (loginResult.type === "userLogin/rejected") {
          Notify("error", loginResult.error.message, "");
          return;
        }

        if (loginResult.type === "userLogin/fulfilled") {
          const token = loginResult.payload?.data?.data?.token;
          const society_name =
            loginResult.payload?.data?.data?.user?.society_name;

          if (token) {
            cookies.set("token", token, { path: "/" });
            cookies.set("society_name", society_name, { path: "/" });
          } else {
            Notify("error", "Oops! Something went wrong. Please try again later.", "");
            return;
          }

          const finalResult = await calluserAuthenticationData();
          if (finalResult.type === "userAuthentication/fulfilled") {
            const authData = finalResult.payload.data.data;
            cookies.set("societyId", authData.society, { path: "/" });
            cookies.set("society_name", society_name, { path: "/" });
            const roles = authData?.roles?.[0];
            cookies.set("role", roles, { path: "/" });

            if (roles === "admin") {
              navigate("/dashboard");
            } else {
              navigate("/president-dashboard");
            }

            Notify("success", "Login successful. Welcome back !", "");
          } else {
            cookies.remove("token");
            Notify("error", "Access Denied. Please enter valid details", "");
          }
        }
      } catch (err) {
        Notify("error", "Oops! Something went wrong. Please try again later.", "");
      }
    }
  };

  return (
    <div>
      <LoginComponent
        handleSubmit={handleSubmit}
        handleLogin={handleLogin}
        validation={validation}
        handelotp={handleOtp}
        loading={loading}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  userLoginData: state.userLoginData,
  userAuthenticationData: state.userAuthenticationData,
});

const mapDispatchToProps = (dispatch) => ({
  calluserLoginData: (data) => dispatch(userLogin(data)),
  calluserAuthenticationData: () => dispatch(userAuthentication()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
